import template from "./navbar.html";

const NavbarComponent = {
  template: template,
  bindings: {
    minima: "<",
  },
  controller: class NavbarController {
    /* @ngInject */
    constructor($rootScope) {
      this.$rootScope = $rootScope;
    }

    toggleSidebar() {
      this.$rootScope.isSidebarActive = !this.$rootScope.isSidebarActive;
    }

    closeSidebar() {
      this.$rootScope.isSidebarActive = false;
    }
  },
};

export default NavbarComponent;
